import React from 'react';

interface AnimatedBackgroundProps {
  children: React.ReactNode;
}

export const AnimatedBackground: React.FC<AnimatedBackgroundProps> = ({
  children,
}) => {
  return (
    <div className="relative">
      {/* Animated background shapes */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 -left-32 h-64 w-64 animate-[pulse_8s_ease-in-out_infinite] rounded-full bg-gradient-to-br from-[#FF732E]/5 to-[#E65A1F]/5 blur-3xl" />
        <div className="absolute -right-32 bottom-0 h-64 w-64 animate-[pulse_10s_ease-in-out_infinite] rounded-full bg-gradient-to-tl from-[#FF732E]/5 to-[#E65A1F]/5 blur-3xl" />
      </div>

      {/* Content */}
      <div className="relative flex min-h-[400px] flex-col items-center justify-center">
        {children}
      </div>
    </div>
  );
};
